import { DomQuery } from "./dom-query";

type ElementCtor<T extends Element> = abstract new (...args: never[]) => T;

export class FormBase {
    protected queryElement<T extends Element = HTMLElement>(
        root: ParentNode | null | undefined,
        selector: string,
        elementClass?: ElementCtor<T>,
    ): T | null {
        return DomQuery.queryElement(root, selector, elementClass);
    }

    protected queryElements<T extends Element = HTMLElement>(
        root: ParentNode | null | undefined,
        selector: string,
        elementClass?: ElementCtor<T>,
    ): T[] {
        return DomQuery.queryElements(root, selector, elementClass);
    }

    protected getForm(
        root: ParentNode | Event | EventTarget | Element | null | undefined,
        selector?: string,
    ): HTMLFormElement | null {
        return DomQuery.getForm(root, selector);
    }

    protected getInput(
        root: ParentNode | Event | EventTarget | Element | null | undefined,
        selector?: string,
    ): HTMLInputElement | null {
        return DomQuery.getInput(root, selector);
    }

    protected getTextarea(
        root: ParentNode | Event | EventTarget | Element | null | undefined,
        selector?: string,
    ): HTMLTextAreaElement | null {
        return DomQuery.getTextarea(root, selector);
    }

    protected getButton(
        root: ParentNode | Event | EventTarget | Element | null | undefined,
        selector?: string,
    ): HTMLButtonElement | null {
        return DomQuery.getButton(root, selector);
    }

    protected fromEventTarget<T extends Element = HTMLElement>(
        root: Event | EventTarget | Element | null | undefined,
        elementClass?: ElementCtor<T>,
    ): T | null {
        return DomQuery.fromEventTarget(root, elementClass);
    }

    protected closest<T extends Element = HTMLElement>(
        root: Event | EventTarget | Element | null | undefined,
        selector: string,
        elementClass?: ElementCtor<T>,
    ): T | null {
        return DomQuery.closest(root, selector, elementClass);
    }
}
